import menuData from './mock/menuData.json'
import rootMenuList from './mock/rootMenu.json'
import menuLangData from './mock/menuLangData.json'
import menuActions from './mock/menuActions.json'
import customActions from './mock/customActions.json'
import request from '@/utils/request'
import { isUseAPI, isMobile } from '@/utils/check'
import orgData from './mock/org.json'
import envs from '@/envs'
import menuMockupData from './mock/menuData_2.0.0.json'
import etcUserData from './mock/etcUserData'
import etcOrgData from './mock/etcOrgData'

export function getUserMenus(params) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    let device = 'P'
    if (isMobile()) {
      device = 'M'
    }
    return request({
      url: '/menu/userMenus/' + device + '/user_id/' + params,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(menuMockupData))
  })
}

// 최상위 메뉴 리스트를 조회한다.
export function getRootMenuList(retrieveData) {
  if (isUseAPI()) {
    return request({
      url: `/hiway/menus/root`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
}

export function getEtcUser(retrieveData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/users/etc`,
      method: 'get',
      params: retrieveData,
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(etcUserData))
  })
}
export function saveEtcUser(retrieveData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/users/etc`,
      method: 'post',
      data: retrieveData,
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(etcUserData))
  })
}
export function editEtcUser(retrieveData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/users/etc`,
      method: 'put',
      data: retrieveData,
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(etcUserData))
  })
}
export function deleteEtcUser(retrieveData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/users/etc`,
      method: 'delete',
      data: retrieveData.deleted,
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(etcUserData))
  })
}
// 조직 유형 리스트를 조회한다.
export function getOrgType() {
  if (isUseAPI()) {
    return request({
      url: `/hiway/common/code/SY011`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
  })
}
export function getEtcOrg(retrieveData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/organizations/companies/etc`,
      method: 'get',
      params: retrieveData,
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(etcOrgData))
  })
}
export function saveEtcOrg(retrieveData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/organizations/companies/etc`,
      method: 'post',
      data: retrieveData,
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(etcUserData))
  })
}
export function deleteEtcOrg(retrieveData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/organizations/companies/etc`,
      method: 'delete',
      data: [ retrieveData ],
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(etcUserData))
  })
}

export function CheckEtcOrgAsgnCd(asgnCd) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/organizations/companies/etc/${asgnCd}`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(etcUserData))
  })
}
export function getUserMenu() {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/menus`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(menuMockupData))
  })
}

export function getMenus() {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/menus/apps/${envs.systemId}`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(menuMockupData))
  })
}

export function getCompanys() {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/organizations/companies`,
      method: 'get',
      meta: {
        apiVersion: '2.0.0'
      }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(orgData))
  })
}
export function getOrg(retrieveData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    let params = { asgn_cd: retrieveData.asgn_cd }
    return request({
      url: `/hiway/organizations/company/${retrieveData.company}`,
      method: 'get',
      meta: {
        apiVersion: '2.0.0'
      },
      params
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(orgData))
  })
}
// 메뉴 리스트를 조회한다.
export function getMenuList(retrieveData) {
  if (isUseAPI()) {
    // 메뉴 아이디가 존재하면 메뉴 아이디를 넣어 검색한다.
    // if (retrieveData.menu_id) {
    //   return request({
    //     // url: `/hiway/menus/${retrieveData.app_id}/${
    //     //   retrieveData.menu_id
    //     // }?pgm_id=${retrieveData.pgmid}`,
    //     url: `/hiway/menus/${retrieveData.menu_id}`,
    //     method: 'get',
    //     meta: { apiVersion: '2.0.0' }
    // })
    // }

    // console.log('104 retrieveData >>>>>>>>>>>>>>>>', retrieveData)
    return request({
      // url: `/hiway/menus/${retrieveData.app_id}?pgm_id=${
      //   retrieveData.pgmid
      // }`,
      url: `/hiway/menus/apps/${retrieveData.app_id}`,
      // url: `/hiway/menus/apps/${envs.systemId}`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }

  if (retrieveData.menu_id) {
    return new Promise(function(resolve, reject) {
      let res = menuData['all']
      resolve(_.cloneDeep(res))
    })
  } else {
    return new Promise(function(resolve, reject) {
      let res
      if (!retrieveData.app_id) {
        res = menuData['all']
      } else {
        res = menuData[retrieveData.app_id]
      }
      resolve(_.cloneDeep(res))
    })
  }
}

// 메뉴 유형 리스트를 조회한다.
export function getMenuActions(retrieveData) {
  if (isUseAPI()) {
    return request({
      url: `/hiway/common/code/SY007`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(menuActions)
  })
}

// 메뉴 유형 리스트를 조회한다.
export function getMenuLangList(retrieveData) {
  // if (isUseAPI()) {
  return request({
    url: `/hiway/menulangs/apps/${retrieveData.app_id}/menus/${
      retrieveData.menu_id
    }`,
    method: 'get',
    // meta: { apiVersion: '2.0.0', useProgress: false }
    meta: { apiVersion: '2.0.0' }
  })
  // }

  // return new Promise(function(resolve, reject) {
  //   var res = menuLangData[retrieveData.menu_id]
  //   if (!res) res = menuLangData['all']
  //   resolve(_.cloneDeep(res))
  // })
}

// 메뉴 유형 리스트를 조회한다.
export function getCustomActions(retrieveData) {
  if (isUseAPI()) {
    return request({
      url: `/hiway/menus/custom`,
      method: 'get'
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(customActions)
  })
}

export function deleteMenu(rowData) {
  // if (isUseAPI()) {
  return request({
    url: `/hiway/menus/apps/${rowData.app_id}/menus/${rowData.menu_id}`,
    method: 'delete',
    data: rowData,
    meta: { apiVersion: '2.0.0' }
  })
}

export function saveMenus(saveData) {
  console.log('saveData', saveData)
  console.log('162 &&&&&&&&&&&&&&&&&&&&', saveData.retrieveData.app_id)
  return request({
    url: `/hiway/menus/apps/${saveData.retrieveData.app_id}`,
    method: 'post',
    data: saveData,
    meta: { apiVersion: '2.0.0' }
  })
  //   // if (isUseAPI()) {
  //   var saveActions = []
  //   // 수정할 데이터들을 API 룰에 맞게 셋팅하는 함수, update
  //   // console.log('saveData >>>>>>>>>>>>>>.', saveData)
  //   // console.log('rowData >>>>>>>>>>>>>>.', rowData)
  //   var updatedAction = function(rowData) {
  //     return request({
  //       url: `/hiway/menus/${rowData.app_id}/${rowData.menu_id}`,
  //       method: 'put',
  //       data: [rowData],
  //       meta: { apiVersion: '2.0.0' }
  //     })
  //   }

  //   // 추가할 데이터들을 API 룰에 맞게 셋팅하는 함수, insert
  //   var createdAction = function(rowData) {
  //     return request({
  //       url: `/hiway/menus/${rowData.app_id}`,
  //       method: 'post',
  //       data: [rowData],
  //       meta: { apiVersion: '2.0.0' }
  //     })
  //   }

  //   // created 에 추가할 데이터들이 담겨있으면 API 룰에 맞게 셋팅하는 함수 호출
  //   // 한번에 여러개의 데이터를 배열로 묶어 보낼 수 있다.
  //   if (saveData.created && saveData.created.length > 0) {
  //     saveData.created.forEach(rowData => {
  //       saveActions.push(createdAction(rowData))
  //     })
  //   }
  //   // updated 에 수정할 데이터들이 담겨있으면 API 룰에 맞게 셋팅하는 함수 호출
  //   // 한번에 여러개의 데이터를 배열로 묶어 보낼 수 있다.
  //   if (saveData.updated && saveData.updated.length > 0) {
  //     saveData.updated.forEach(rowData => {
  //       saveActions.push(updatedAction(rowData))
  //     })
  //   }
  //   // // deleted 에 삭제할 데이터들이 담겨있으면 API 룰에 맞게 셋팅하는 함수 호출
  //   // // 한번에 여러개의 데이터를 배열로 묶어 보낼 수 있다.
  //   // if (saveData.deleted && saveData.deleted.length > 0) {
  //   //   saveActions.push(deletedAction(saveData.deleted))
  //   // }

  //   // 추가 수정 삭제를 각각 실행할경우 한번 실행시마다 화면으로 리턴값을 넘겨주게 되므로
  //   // 끝나는 시점이 애매하기 때문에 all 을 이용해 한번에 넘긴다.
  //   // 전체가 성공했을때 then, 하나라도 실패했을때 catch 를 타게 된다.
  //   return axios
  //     .all(saveActions)
  //     .then(reponse => {
  //       return '200'
  //     })
  //     .catch(error => {
  //       return error
  //     })
  //   // }

  //   // return new Promise(function(resolve, reject) {
  //   //   resolve('200')
  //   // })
}

export function saveLangs(saveData) {
  // if (isUseAPI()) {
  // var saveActions = []
  // // 수정할 데이터들을 API 룰에 맞게 셋팅하는 함수
  // var updatedAction = function(rowData) {
  return request({
    url: `/hiway/menulangs/apps/${saveData.retrieveData.app_id}/menus/${
      saveData.retrieveData.menu_id
    }`,
    method: 'post',
    data: saveData.updated,
    meta: { apiVersion: '2.0.0' }
  })
  // }
  // updated 에 수정할 데이터들이 담겨있으면 API 룰에 맞게 셋팅하는 함수 호출
  // 한번에 여러개의 데이터를 배열로 묶어 보낼 수 있다.
  // if (saveData.updated && saveData.updated.length > 0) {
  //   saveActions.push(updatedAction(saveData.updated))
  // }

  // 추가 수정 삭제를 각각 실행할경우 한번 실행시마다 화면으로 리턴값을 넘겨주게 되므로
  // 끝나는 시점이 애매하기 때문에 all 을 이용해 한번에 넘긴다.
  // 전체가 성공했을때 then, 하나라도 실패했을때 catch 를 타게 된다.
  // return axios
  //   .all(saveActions)
  //   .then(reponse => {
  //     return '200'
  //   })
  //   .catch(error => {
  //     return error
  //   })
  // }

  // return new Promise(function(resolve, reject) {
  //   resolve('200')
  // })
}

// 시스템별 메뉴 트리 목록을 조회한다.
export function getAppMenuTreeList(retrieveData) {
  return request({
    url: `/hiway/menus/apps/${retrieveData.app_id}`,
    meta: { apiVersion: '2.0.0' },
    method: 'get'
  })
}
